var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195ff51c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterSlogan.vue
// module id = RSxB
// module chunks = 1